import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { CellContext } from '@tanstack/react-table';

export interface CustomerListHolderEmailCellProps
  extends CellContext<
    GatewayCustomerModel,
    NonNullable<GatewayCustomerModel['holder']>['email'] | undefined
  > {}

export const CustomerListHolderEmailCell = (
  props: CustomerListHolderEmailCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
